export default "__VITE_ASSET__ZPqosppc__"